export default __webpack_public_path__ + "static/john-704e52d9f53a156cc8f2c88d04d5abda.png";